export default "__VITE_ASSET__BZAneeOg__"